module.exports = __webpack_public_path__ + "static/media/YFI.d7418691.png";